import { getAnchor } from './helper'

export class Collapse {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        collapseItem: '.collapse-block__item',
        collapseItemOpen: '.collapse-block__item--open',
        collapseContainer: '.collapse-block__container',
        toggleButton: '.collapse-block__title, .collapse-block__close'
      },
      classes: {
        collapseItemOpen: 'collapse-block__item--open'
      }
    },
    settings)
  }

  init () {
    this.addEvents()
    this.setAnchorElementActive()
  }

  addEvents () {
    const that = this
    let collapseResizeTimer

    $(that.options.selectors.toggleButton)
      .on({
        'click focus': function (event) {
          const item = $(this).closest(that.options.selectors.collapseItem)
          const container = item.find(that.options.selectors.collapseContainer)

          if (item.hasClass(that.options.classes.collapseItemOpen)) {
            if (event.type !== 'focus') {
              container
                .css('height', '')

              item
                .removeClass(that.options.classes.collapseItemOpen)
            }
          } else {
            container
              .css('height', 'auto')

            const containerHeight = container.outerHeight()

            container
              .css('height', '0')

            setTimeout(function () {
              item
                .addClass(that.options.classes.collapseItemOpen)

              container
                .css('height', containerHeight + 'px')
            }, 30)
          }
        }
      })

    $(window)
      .resize(function () {
        clearTimeout(collapseResizeTimer)

        collapseResizeTimer = setTimeout(function () {
          that.resetHeights()
        }, 250)
      })
  }

  resetHeights () {
    const that = this

    $(that.options.selectors.collapseItemOpen)
      .each(function () {
        const item = $(this)

        const container = item.find(that.options.selectors.collapseContainer)

        container
          .css('height', 'auto')

        const containerHeight = container.outerHeight()

        container
          .css('height', '0')

        container
          .css('height', containerHeight + 'px')
      })
  }

  setAnchorElementActive () {
    const anchor = getAnchor()
    const that = this

    if (anchor) {
      setTimeout(function () {
        $(that.options.selectors.collapseItem)
          .filter('#' + anchor)
          .find(that.options.selectors.toggleButton)
          .trigger('click')
      }, 300)
    }
  }
}

export default Collapse
